import { render, staticRenderFns } from "./AdminStructureForm.vue?vue&type=template&id=9ef4ce62"
import script from "./AdminStructureForm.vue?vue&type=script&lang=js"
export * from "./AdminStructureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports